import { snakeCaseToTitleCase } from "common/utils/strings";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_143: DocMigration = {
  maxSchemaVersion: "0.0.143",
  description: "New window settings",
  apply(json: any) {
    const { levels } = json;

    for (const levelId in levels) {
      const level = levels[levelId];
      const { windowHeadHeight } = level;
      delete level.windowHeadHeight;

      const levelUniqueId = uid();
      level.uniqueId = levelUniqueId;

      // add new windows settings to the level settings
      const windowSettingsId = uid();
      json.settings = {
        ...json.settings,
        [windowSettingsId]: {
          entityType: "SETTINGS",
          id: windowSettingsId,
          type: "WINDOW_SETTINGS",
          windowHeadHeight,
          parentId: levelUniqueId,
          sortIndex: 0,
          name: snakeCaseToTitleCase("WINDOW_SETTINGS"),
        },
      };
    }

    return json;
  },
};

export default migration_0_0_143;
